import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-pwa-studio/commerce-pwa-studio/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`An ECMAScript module that can be changed by a third party.`}</p>
    <p>{`This class presents a convenient API for consumers to add common transforms to ES
Modules in a semantic way.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#TargetableESModule"
        }}>{`TargetableESModule`}</a>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "#TargetableESModule+addImport"
            }}>{`.addImport(statement)`}</a>{` ⇒ `}<inlineCode parentName="li">{`SingleImportStatement`}</inlineCode></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#TargetableESModule+uniqueIdentifier"
            }}>{`.uniqueIdentifier(binding)`}</a>{` ⇒ `}<inlineCode parentName="li">{`string`}</inlineCode></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#TargetableESModule+wrapWithFile"
            }}>{`.wrapWithFile([exportName], wrapperModule)`}</a>{` ⇒ `}<inlineCode parentName="li">{`this`}</inlineCode></li>
        </ul>
      </li>
    </ul>
    <p>{`Adds a static import statement to the module source code, thus importing
a new dependency.`}</p>
    <p>{`This method automatically deduplicates attempts to add imports that would override
earlier import bindings.
If a collision is detected, it renames the binding before inserting it.`}</p>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<inlineCode parentName="p">{`SingleImportStatement`}</inlineCode>{`
— An instance of the `}<inlineCode parentName="p">{`SingleImportStatement`}</inlineCode>{` class.`}</p>
    <p><strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`statement`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`SingleImportStatement`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A string representing the import statement, or a SingleImportStatement representing it.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Generates a unique identifier for a given binding. Not guaranteed safe,
but good enough in a pinch.`}</p>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`binding`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The binding to change.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Pass exports of this module through a wrapper module.`}</p>
    <p><strong parentName="p">{`Chainable`}</strong><br parentName="p"></br>{`
`}<strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[exportName]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Name of export to wrap. If not provided, will wrap the default export.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`wrapperModule`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Package-absolute import path to the wrapper module.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Source Code`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://github.com/magento/pwa-studio/blob/develop/packages/pwa-buildpack/lib/WebpackTools/targetables/TargetableESModule.js"
      }}>{`pwa-studio/packages/pwa-buildpack/lib/WebpackTools/targetables/TargetableESModule.js`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      